export class DattaConfig {
  public static config = {
    layout: "vertical", // vertical, horizontal
    "pre-layout": "layout-6", // null, layout-2, layout-2-2, layout-3, layout-4, layout-4-2, layout-6, layout-8
    "collapse-menu": false,
    "layout-type": "dark", // menu-dark, menu-light, dark
    "nav-icon-color": false,
    "header-back-color": "header-default", // header-default, header-blue, header-red, header-purple, header-lightblue, header-dark
    "nav-back-color": "navbar-dark", // navbar-default, navbar-blue, navbar-red, navbar-purple, navbar-lightblue, navbar-dark
    "nav-brand-color": "brand-dark", // brand-default, brand-blue, brand-red, brand-purple, brand-lightblue, brand-dark
    "nav-back-image": false, // false, navbar-image-1, navbar-image-2, navbar-image-3, navbar-image-4, navbar-image-5
    "rtl-layout": false,
    "nav-fixed-layout": false,
    "header-fixed-layout": false,
    "box-layout": false,
    "nav-dropdown-icon": "style1", // style1, style2, style3
    "nav-list-icon": "style4", // style1, style2, style3, style4, style5, style6
    "nav-active-list-color": "active-default", // active-default, active-blue, active-red, active-purple, active-lightblue, active-dark
    "nav-list-title-color": "title-default", // title-default, title-blue, title-red, title-purple, title-lightblue, title-dark
    "nav-list-title-hide": true,
    "layout-6-background": "#424448", // #23b7e5 used only for pre-layout = layout-6
  };

  public static configApp = {
    layout: "vertical", // vertical, horizontal
    "pre-layout": null, // null, layout-2, layout-2-2, layout-3, layout-4, layout-4-2, layout-6, layout-8
    "collapse-menu": false,
    "layout-type": "menu-dark", // menu-dark, menu-light, dark
    "nav-icon-color": false,
    "header-back-color": "header-dark", // header-default, header-blue, header-red, header-purple, header-lightblue, header-dark
    "nav-back-color": "navbar-dark", // navbar-default, navbar-blue, navbar-red, navbar-purple, navbar-lightblue, navbar-dark
    "nav-brand-color": "brand-dark", // brand-default, brand-blue, brand-red, brand-purple, brand-lightblue, brand-dark
    "nav-back-image": false, // false, navbar-image-1, navbar-image-2, navbar-image-3, navbar-image-4, navbar-image-5
    "rtl-layout": false,
    "nav-fixed-layout": false,
    "header-fixed-layout": true,
    "box-layout": false,
    "nav-dropdown-icon": "style1", // style1, style2, style3
    "nav-list-icon": "style1", // style1, style2, style3, style4, style5, style6
    "nav-active-list-color": "active-default", // active-default, active-blue, active-red, active-purple, active-lightblue, active-dark
    "nav-list-title-color": "title-dark", // title-default, title-blue, title-red, title-purple, title-lightblue, title-dark
    "nav-list-title-hide": true,
    "layout-6-background": "#23b7e5", // used only for pre-layout = layout-6
  };

  public static configApp2 = {
    layout: "vertical", // vertical, horizontal
    "pre-layout": null, // null, layout-2, layout-2-2, layout-3, layout-4, layout-4-2, layout-6, layout-8
    "collapse-menu": false,
    "layout-type": "menu-dark", // menu-dark, menu-light, dark
    "nav-icon-color": false,
    "header-back-color": "header-default", // header-default, header-blue, header-red, header-purple, header-lightblue, header-dark
    "nav-back-color": "navbar-default", // navbar-default, navbar-blue, navbar-red, navbar-purple, navbar-lightblue, navbar-dark
    "nav-brand-color": "brand-default", // brand-default, brand-blue, brand-red, brand-purple, brand-lightblue, brand-dark
    "nav-back-image": false, // false, navbar-image-1, navbar-image-2, navbar-image-3, navbar-image-4, navbar-image-5
    "rtl-layout": false,
    "nav-fixed-layout": true,
    "header-fixed-layout": true,
    "box-layout": false,
    "nav-dropdown-icon": "style1", // style1, style2, style3
    "nav-list-icon": "style1", // style1, style2, style3, style4, style5, style6
    "nav-active-list-color": "active-default", // active-default, active-blue, active-red, active-purple, active-lightblue, active-dark
    "nav-list-title-color": "title-default", // title-default, title-blue, title-red, title-purple, title-lightblue, title-dark
    "nav-list-title-hide": true,
    "layout-6-background": "#23b7e5", // used only for pre-layout = layout-6
  };
}
